import {
  type ExamEventCardProps,
  type ExamEventCardVariants,
} from '@exam-center/exam-event-schedule';
import {
  RegistrationType,
  type ExamEvent,
  type GetUpcomingExamEventsByExamCenterCodeQuery,
} from '@exam-center/graphql';
import { dayjs } from '@shared/utils';

const EXAM_EVENT_REGISTRATION_STATUS_TO_EXAM_EVENT_CARD_VARIANT: Record<
  ExamEvent['registrationStatus'],
  ExamEventCardVariants
> = {
  OPEN_FOR_REGISTRATION: 'open-for-registration',
  REGISTRATION_CLOSED: 'registration-closed',
  SESSION_FULL: 'session-full',
  CANCELED: 'canceled',
  TEMPORARILY_CLOSED: 'temporarily-closed',
  SCHEDULED: 'scheduled',
};

export function mapExamEventsToExamEventCard(
  examEvents: GetUpcomingExamEventsByExamCenterCodeQuery['ecGetUpcomingExamEventsByExamCenterCode']['examEvents'],
): (ExamEventCardProps & { id: string })[] {
  return examEvents.map((examEvent) => ({
    id: examEvent.id,
    type: examEvent.registrationType === RegistrationType.Public ? 'public' : 'in-house',
    variant:
      EXAM_EVENT_REGISTRATION_STATUS_TO_EXAM_EVENT_CARD_VARIANT[examEvent.registrationStatus],
    time: `${dayjs(examEvent.examStartedAt).format('HH:mm')} - ${dayjs(
      examEvent.examEndedAt,
    ).format('HH:mm')}`,
    title: examEvent.name,
    location: `${examEvent.examLocation.nameTh}, ${examEvent.examLocation.province.nameTh}`,
    seat: examEvent.numberOfExaminees ?? 0,
    examDate: dayjs(examEvent.examStartedAt).format('DD-MM-YYYY'),
    roundNumber: examEvent.roundNumber,
    maximumSeat: examEvent.seat,
    examCenterCode: examEvent.examCenterCode,
  }));
}
